const initialState = {}

const UIReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'UI':
            return {
                ...state,
                FAQs: action.data ? action.data.FAQs : [],
                guides: action.data ? action.data.guides : [],
                about_us: action.data ? action.data.about_us : {},
                about_us_advert: action.data ? action.data.about_us_advert : {},
                general: action.data ? action.data.general : {},
                home: action.data ? action.data.home : {},
                cv_information: action.data ? action.data.cv_information : {},
                seo_pages: action.data ? action.data.seo_pages : {},
                job_categories: action.data ? action.data.job_categories : {},
                provinces: action.data ? action.data.provinces : {},
            }
        default:
            return state
    }
}

export default UIReducer
